<template>
  <div class="container">
    <div class="headerImg">
      <div class="mainTitle">{{ title }}</div>
    </div>
    <div class="main">
      <div v-for="item,i in list" :key="i" class="rowItem">
        <img src="../../assets/14.png" alt class="rowIcon" />
        <div class="overHidden" @click="$router.push({path:'/news/detail',query:{id:item.id}})">
          <div class="news-t">{{ item.title }}</div>
          <div class="news-oper">
            <div class="pageItemBtn" @click="$router.push({path:'/news/detail',query:{id:item.id}})">
              <i class="el-icon-view" style="color: #fff;margin-right: 3px;"></i>
              <div style="color: #fff;">详情</div>
            </div>
          </div>
        </div>
      </div>
      <EmptyList v-if="list.length == 0"></EmptyList>
    </div>
    <div class="pagin-box">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { indexNews } from "@/api/index.js";
export default {
  name: "newList",
  data() {
    return {
      title: "新闻政策列表",
      list: [],
      level: "",
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      indexNews({ ...this.queryParams }).then(res => {
        this.list = res.data.list;
        this.total = res.data.total;
      });
    }
  }
};
</script>

<style>
.container {
  padding-bottom: 20px;
}
.headerImg {
  background-image: url("../../assets/news.png");
  min-width: 1200px;
  height: 180px;
}

.mainTitle {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #fff;
  text-shadow: 0 0 3px #3f93f6, 0 0 3px #3f93f6, 0 0 3px #3f93f6,
    0 0 3px #3f93f6;
}
.main {
  width: 1200px;
  min-height: calc(100vh - 421px);
  margin: 0px auto;
  background-color: #fff;
  margin-top: 20px;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 0px 20px;
}
.pagin-box {
  width: 1200px;
  margin: 20px auto 0;
  border-radius: 10px;
  overflow: hidden;
}
.rowItem {
  padding: 30px 0;
  border-bottom: 1px solid #eee;
  font-size: 17px;
  color: #000;
  display: flex;
}
.rowIcon {
  width: 16px;
  height: 18px;
  margin-top: 3px;
  margin-right: 10px;
  flex-shrink: 0;
}
.news-oper .pageItemBtn {
  width: 60px;
  height: 25px;
  font-size: 13px;
  background-color: #409eff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}
.news-oper .pageItemBtn:hover {
  background-color: #7ab7f5;
}
.overHidden {
  width: calc(100% - 26px);
  display: flex;
  justify-content: space-between;
}
.news-t {
  width: calc(100% - 100px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-oper {
}
</style>